/* 森と、 morito — スクロール演出・スマホ固定ボタン・サイドバー・選択肢 */
(function () {
  if (window.__morito) return;
  window.__morito = true;
  document.documentElement.classList.add('mr-js');

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // スクロールでふわっと表示
    var items = document.querySelectorAll('.mr-reveal');
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }

    // スマホ固定ボタン：ヒーローを過ぎたら出し、フッター付近では隠す
    var bar = document.querySelector('.mr-sticky');
    if (bar) {
      var hero = document.querySelector('.mr-hero');
      var footer = document.querySelector('footer, .footer, [id*="footer"]');
      var update = function () {
        var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        var nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('is-visible', past && !nearEnd);
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
  }

  // ── サイドバー（MENU） ──
  var lastFocus = null;
  function openDrawer(d) {
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.classList.add('mr-lock');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = d.querySelector('.mr-drawer__panel button, .mr-drawer__panel a, .mr-drawer__panel input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('mr-lock');
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 420);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mr-drawer-open]');
    if (o) { openDrawer(document.getElementById(o.getAttribute('aria-controls'))); return; }
    var c = e.target.closest('[data-mr-drawer-close]');
    if (c) closeDrawer(c.closest('[data-mr-drawer]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mr-drawer].is-open').forEach(closeDrawer);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('[data-mr-drawer]');
    if (d) openDrawer(d);
  });
  document.addEventListener('shopify:section:deselect', function () {
    document.querySelectorAll('[data-mr-drawer].is-open').forEach(closeDrawer);
  });

  // ── 選択肢（あり／なし）で価格・ボタン・写真を切り替え ──
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.name !== 'id') return;
    var box = el.closest('[data-mr-buy]');
    if (!box) return;
    var src = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
    var price = box.querySelector('[data-mr-price]');
    var excl = box.querySelector('[data-mr-excl]');
    var add = box.querySelector('[data-mr-add]');
    var dyn = box.querySelector('[data-mr-dynamic]');
    var ok = src.getAttribute('data-available') === 'true';
    if (price) price.textContent = src.getAttribute('data-price');
    if (excl) excl.textContent = src.getAttribute('data-excl');
    if (add) { add.disabled = !ok; add.textContent = ok ? box.getAttribute('data-add') : box.getAttribute('data-soldout'); }
    if (dyn) dyn.hidden = !ok;
    var pdp = box.closest('.mr-pdp');
    if (pdp) {
      try { var u = new URL(location.href); u.searchParams.set('variant', el.value); history.replaceState(null, '', u); } catch (err) {}
      var mid = src.getAttribute('data-media');
      var media = pdp.querySelector('.mr-pdp__media');
      var fig = mid && media && media.querySelector('[data-media-id="' + mid + '"]');
      if (fig) {
        if (media.scrollWidth > media.clientWidth + 4) media.scrollTo({ left: fig.offsetLeft - media.offsetLeft, behavior: 'smooth' });
        else media.insertBefore(fig, media.firstElementChild);
      }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // テーマエディタでセクションを追加・変更したときも表示されるように
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.mr-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
